<template>
  <div>
    <add-new-affiliate-popup
      :show="isNewAffiliatePopupDisplayed"
      :loading="waitingForNewAffiliate"
      @close="isNewAffiliatePopupDisplayed = false"
      @newAffiliate="
        (structureName) => {
          createNewAffiliate(structureName);
        }
      "
    />

    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="text-4xl text-gray-900">Liste des affiliations</p>
        <p
          class="mt-2 text-base font-light leading-4 2xl:leading-5 text-gray-600 xl:pr-72"
        >
          Attribuer un lien d'affiliation aux structures inscrites sur le
          Neopass ou des structures non inscrites qui veulent affiliés d'autres
          structures.
        </p>
      </div>
      <illustration
        name="Group189"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>
    <div>
      <!-- Contenu -->
      <div class="flex flex-col mt-16 mb-16">
        <div class="-my-2 py-2">
          <div
            class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
          >
            <h3 class="mt-15 mb-10 lg:mb-15 w-full">Affiliations</h3>

            <!-- Affiliates tabs -->
            <div
              class="flex space-x-10 justify-center text-center text-gray-600 cursor-pointer"
            >
              <div
                class="transform hover:scale-110 transition-transform duration-300 text-2xl hover:text-pink-600 font-light"
                :class="{
                  'text-indigo-600': tabDisplay === 'neopass',
                }"
                @click="tabDisplay = 'neopass'"
              >
                Structures Neopass
              </div>
              <div
                class="transform hover:scale-110 transition-transform duration-300 text-2xl hover:text-pink-600 font-light"
                :class="{
                  'text-indigo-600': tabDisplay === 'noSub',
                }"
                @click="tabDisplay = 'noSub'"
              >
                Structures non inscrites
              </div>
            </div>
            <!-- End Affiliates tabs -->

            <!-- Content -->
            <div v-if="tabDisplay === 'neopass'">
              <div
                class="h-16 lg:h-24 2xl:h-32 text-lg text-gray-600 grid grid-cols-6 gap-x-4 place-content-center mt-10"
              >
                <div class="ml-15 col-span-2">Utilisateur</div>
                <div class="col-span-2">Structure</div>
                <div class="col-span-2">Nombre d'affiliations</div>
              </div>

              <div
                v-if="isLoading"
                class="flex items-center justify-center w-full"
              >
                <span
                  class="w-5 h-5 rounded-full border-t-2 border-r animate-spin border-gray-600"
                />
              </div>

              <div
                v-for="(structure, idStru) in listStructures"
                :key="idStru"
                class="h-16 lg:h-24 2xl:h-32 text-base bg-gray-100 even:bg-opacity-50 grid grid-cols-6 gap-x-4 place-content-center items-center"
              >
                <div class="ml-15 col-span-2">
                  {{ structure?.admin?.firstname }}
                  {{ structure?.admin?.lastname }}
                </div>
                <div class="col-span-2">
                  {{ structure?.name }}
                </div>
                <div class="col-span-2">
                  {{ structure?.admin?.affiliate_count }}
                </div>
              </div>
            </div>

            <div v-if="tabDisplay === 'noSub'">
              <add-button
                class="m-10 w-max"
                libelle="Ajouter un lien affilié"
                @add="displayNewAffiliatePopup()"
              />
              <div
                class="h-16 lg:h-24 2xl:h-32 text-lg text-gray-600 grid grid-cols-12 gap-x-4 place-content-center"
              >
                <div class="ml-15 col-span-2">Structure</div>
                <div class="col-span-5">Lien d'affiliation</div>
                <div class="col-span-2">Copier le lien</div>
                <div class="col-span-2">Nombre d'affiliations</div>
              </div>

              <div
                v-for="(structure, idStru) in affiliates"
                :key="idStru"
                class="h-16 lg:h-24 2xl:h-32 text-base bg-gray-100 even:bg-opacity-50 grid grid-cols-12 gap-x-4 place-content-center items-center"
              >
                <div class="ml-15 col-span-2">
                  {{ structure.name }}
                </div>
                <div class="col-span-5">
                  {{ baseUrl + '?affiliate=' + structure.code }}
                </div>
                <div class="col-span-2 relative">
                  <action-button
                    border-color="border-transparent"
                    text-color="text-white"
                    bg-color="bg-indigo-600"
                    libelle="Copier"
                    icon="copy"
                    @clickAction="
                      copyAffiliateLink(
                        baseUrl + '?affiliate=' + structure.code,
                        idStru
                      )
                    "
                  />
                  <transition
                    enter-active-class="duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="duration-300"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
                  >
                    <tag
                      v-if="linkCopied === idStru"
                      class="absolute right-5 bottom-10"
                      libelle="lien copié"
                      text-size="text-sm"
                      text-font="font-light"
                    />
                  </transition>
                </div>
                <div class="col-span-2">
                  {{ structure?.affiliate_count }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import axios from '../../api';
import Constants from './../../constants';
import ClickOutside from 'vue-click-outside';

import AddButton from '../../components/Inputs/AddButton.vue';
import Illustration from './../../components/Illustration';
import ActionButton from '../../components/ActionButton.vue';
import Tag from '../../components/Tag.vue';

import AddNewAffiliatePopup from './popup/AddNewAffiliatePopup.vue';

export default {
  components: {
    AddButton,
    Illustration,
    AddNewAffiliatePopup,
    ActionButton,
    Tag,
  },

  name: 'Affiliates',

  data() {
    return {
      constants: Constants,
      tabDisplay: 'neopass',
      structures: [],
      affiliates: [],
      showInactive: false,
      sort: 'ABC',
      search: '',
      isNewAffiliatePopupDisplayed: false,
      waitingForNewAffiliate: false,
      linkCopied: -1,
      isLoading: false,
    };
  },

  async created() {
    this.isLoading = true;
    await this.loadCompanies();
    await this.loadAffiliates();
    this.isLoading = false;
  },

  methods: {
    ...mapMutations({
      SET_LOADING: 'app/SET_LOADING',
    }),

    async loadCompanies() {
      console.log('Loading companies...');
      await axios
        .get('api/admin/companies')
        .then((response) => {
          this.structures = response.data;
        })
        .catch((err) => {
          console.log('ERRRR:: ', err);
        });
    },

    async loadAffiliates() {
      console.log('Loading affiliates...');
      await axios
        .get('api/admin/affiliates')
        .then((response) => {
          this.affiliates = response.data;
        })
        .catch((err) => {
          console.log('ERRRR:: ', err);
        });
    },

    displayNewAffiliatePopup() {
      this.isNewAffiliatePopupDisplayed = true;
    },

    async createNewAffiliate(structureName) {
      console.log('Creating new affiliate...');
      this.waitingForNewAffiliate = true;
      await axios.post('api/admin/affiliates', { name: structureName });
      await this.loadAffiliates();

      this.isNewAffiliatePopupDisplayed = false;
      this.waitingForNewAffiliate = false;
    },

    copyAffiliateLink(link, num) {
      this.linkCopied = num;
      navigator.clipboard.writeText(link);
      setTimeout(() => {
        this.linkCopied = -1;
      }, 1000);
    },
  },

  computed: {
    structuresFilter: {
      get: function () {
        let filteredList = [];

        filteredList = [...this.structures].filter((structure) =>
          structure.name
            .toLocaleLowerCase()
            .includes(this.search.toLocaleLowerCase())
        );
        return filteredList;
      },
    },

    structuresSort() {
      let sortedList = [];

      if (['ABC', 'ZYX'].includes(this.sort)) {
        sortedList = [...this.structuresFilter].sort(function (a, b) {
          let nameA = a.name.toUpperCase();
          let nameB = b.name.toUpperCase();
          return nameA.localeCompare(nameB);
        });
      }

      if (['JAN', 'DEC'].includes(this.sort)) {
        sortedList = [...this.structuresFilter].sort(function (a, b) {
          let dateA = a.created_at;
          let dateB = b.created_at;
          return dateA.localeCompare(dateB);
        });
      }

      if (['ABC', 'JAN'].includes(this.sort)) {
        return sortedList;
      }
      if (['ZYX', 'DEC'].includes(this.sort)) {
        return sortedList.reverse();
      }
    },

    listStructures() {
      return this.structuresSort.filter(
        (structure) => new Date(structure.expiry_date) >= new Date()
      );
    },

    baseUrl() {
      return process.env.MIX_APP_URL;
    },
  },

  directives: {
    ClickOutside,
  },
};
</script>
